"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//Libraries
//Material-ui
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(2)
    },
    cssLabel: {
      '&$cssFocused': {
        color: theme.palette.primary.contrastText
      },
      color: theme.palette.primary.contrastText
    },
    cssFocused: {},
    cssOutlinedInput: {
      color: theme.palette.primary.contrastText
    },
    cssUnderline: {
      borderBottomColor: theme.palette.primary.contrastText,
      '&:after': {
        borderBottomColor: theme.palette.primary.contrastText
      },
      '&:before': {
        borderBottomColor: theme.palette.primary.contrastText
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottomColor: theme.palette.primary.contrastText
      }
    }
  };
});

var _default = function _default(_ref) {
  var autoFocus = _ref.autoFocus,
      fullWidth = _ref.fullWidth,
      label = _ref.label,
      margin = _ref.margin,
      name = _ref.name,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      type = _ref.type,
      value = _ref.value;
  var classes = useStyles();
  return _react["default"].createElement(_TextField["default"], {
    autoFocus: autoFocus,
    className: classes.root,
    fullWidth: fullWidth,
    label: label,
    margin: margin,
    name: name,
    onChange: onChange,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    type: type,
    value: value,
    InputLabelProps: {
      classes: {
        root: classes.cssLabel,
        focused: classes.cssFocused
      }
    },
    InputProps: {
      classes: {
        root: classes.cssOutlinedInput,
        focused: classes.cssFocused,
        underline: classes.cssUnderline
      }
    }
  });
};

exports["default"] = _default;